/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Source_TitleInputs */

const en_wc_dl_source_title = /** @type {(inputs: Wc_Dl_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build from source`)
};

/**
* | output |
* | --- |
* | "Build from source" |
*
* @param {Wc_Dl_Source_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_source_title = /** @type {((inputs?: Wc_Dl_Source_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Source_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_source_title(inputs)
});
export { wc_dl_source_title as "wc.dl.source_title" }